import { useState } from 'react'
import { nodes as api } from '@/api/endpoints'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { CopyButton } from '@/components/CopyButton'
import { Err } from '@/components/Err'

// 노드 상세 제목 줄의 고급 칩 `root 비밀번호`(A0-5). 시스템이 설치 때 정한 값이라 관리자는 여기서만 본다 —
// 대화 상자의 `보기` 를 누르면 API 가 값을 주고 그 읽기는 노드의 타임라인에 남는다.
// 값은 이 컴포넌트의 state 에만 있고 닫으면 비운다.
export function RootPasswordChip({ nodeId, className }: { nodeId: string; className: string }) {
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const close = () => {
    setOpen(false)
    setValue(null)
    setError(null)
  }
  const reveal = async () => {
    setBusy(true)
    setError(null)
    try {
      setValue(await api.rootPassword(nodeId))
    } catch (err) {
      setError(err)
    } finally {
      setBusy(false)
    }
  }
  return (
    <>
      <button type="button" className={className} onClick={() => setOpen(true)}>
        root 비밀번호
      </button>
      <Dialog open={open} onOpenChange={(next) => (next ? setOpen(true) : close())}>
        <DialogContent aria-describedby={undefined} className="sm:max-w-sm">
          <DialogHeader>
            <DialogTitle>최초 root 비밀번호</DialogTitle>
          </DialogHeader>
          {value === null ? (
            <div>
              <Button size="sm" variant="outline" disabled={busy} onClick={() => void reveal()}>
                {busy ? '여는 중' : '보기'}
              </Button>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <code className="rounded bg-surface-2 px-1.5 py-0.5 font-mono text-[12px]">{value}</code>
              <CopyButton text={value} label="root 비밀번호 복사" icon />
            </div>
          )}
          <Err error={error} />
        </DialogContent>
      </Dialog>
    </>
  )
}
